import ProductAttributesNav from './ProductAttributesNav';

export default ProductAttributesNav;
